import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { AlarmStateFrench } from "src/app/shared/models/alarm/alarm-filter";
import { BaseTableMapper } from "src/app/tinea-components/table/mapper/BaseTableMapper";
import { TableModel } from "src/app/tinea-components/table/models/input/table-model";
import { TableRows } from "src/app/tinea-components/table/models/input/table-rows";
import { TableTd } from "src/app/tinea-components/table/models/input/table-td";
import { TableTh } from "src/app/tinea-components/table/models/input/table-th";
import { ValueCell } from "src/app/tinea-components/table/models/input/value-cell";
import {
  AlarmRealTime,
  AlarmRealTimePaginatedList,
} from "src/swagger-gen/web-secured/models";

@Injectable({
  providedIn: "root",
})
export class TableAlarmListMapper extends BaseTableMapper {
  // -- configuration
  readonly CSS_CLASS_CONFIG = "table-alarms";

  readonly DISPLAY_NO_DATA = "--";

  // -- table
  // css
  readonly CSS_CLASS_NO_SERIOUSNESS = "seriousnessnull";
  readonly CSS_CLASS_SERIOUSNESS_LEVEL1 = "seriousness1";
  readonly CSS_CLASS_SERIOUSNESS_LEVEL2 = "seriousness2";
  readonly CSS_CLASS_ACQUIT = "btn btn__acq";
  readonly CSS_CLASS_RESTORE = "btn btn__restore";
  readonly CSS_CLASS_SERIOUSNESS_ACQUIT = "acquit";
  // icon
  readonly ACTION_ICON1 = "fas fa-eye";
  readonly ACTION_ICON2 = "fas fa-eye-slash";
  readonly ACTION_ICON3 = "fas fa-history";
  // dataId
  readonly COLUMN_ID_SERIOUSNESS = "SERIOUSNESS";
  readonly COLUMN_ID_DATE = "DATE_STATE";
  readonly COLUMN_ID_TAG = "TAG";
  readonly COLUMN_ID_DETAIL = "DETAIL";
  readonly COLUMN_ID_STATION = "STATION_NAME";
  readonly COLUMN_ID_STATE = "STATE";
  // readonly COLUMN_ID_TICKET_ID = "TICKET_ID";
  readonly COLUMN_ID_ACTION = "ACTION";
  readonly ID_ACQUIT_ALARM = "ACQUIT_ALARM_BTN";
  readonly ID_EVENT_HISTORY = "ACQUIT_HISTORY_BTN";
  readonly CSS_STATE_RAISED = "raised";

  // readonly ID_CELL_TICKET_ID = "ID_CELL_TICKET_ID";

  // readonly CSS_TICKET_ID_LINK = "ticketId";

  table: TableModel;
  eUid: string | null;

  alarmStateFrench = AlarmStateFrench; // translation

  constructor(private translate: TranslateService) {
    super();
    this.table = new TableModel();
  }

  init(alarmsList: AlarmRealTimePaginatedList, eUid: string | null = null): TableModel {
    this.eUid = eUid;
    this.table = new TableModel();
    // configuration
    this.initConfiguration();
    // header
    this.initHeader();
    // data
    this.initDataRow(alarmsList);

    return this.table;
  }

  initConfiguration(): void {
    this.table.configuration.cssClass = this.CSS_CLASS_CONFIG;
    this.table.configuration.noDataRowMsg =
      this.translate.instant("error.no_result");
  }

  initHeader(): void {

    const thDate = new TableTh();
    thDate.columnId = this.COLUMN_ID_DATE;
    const thDateCell = new ValueCell();
    thDateCell.displayedValue = this.translate.instant(
      "stations.alarmStation.date"
    );
    thDate.valueCells.push(thDateCell);

    const thDateCreation = new TableTh();
    thDateCreation.columnId = this.COLUMN_ID_DATE;
    const thDateCreationCell = new ValueCell();
    thDateCreationCell.displayedValue = this.translate.instant(
      "stations.alarmStation.dateCreation"
    );
    thDateCreation.valueCells.push(thDateCreationCell);

    const thTag = new TableTh();
    thTag.columnId = this.COLUMN_ID_TAG;
    const thTagCell = new ValueCell();
    thTagCell.displayedValue = this.translate.instant(
      "stations.alarmStation.tag"
    );
    thTag.valueCells.push(thTagCell);

    const thDetail = new TableTh();
    thDetail.columnId = this.COLUMN_ID_DETAIL;
    const thDetailCell = new ValueCell();
    thDetailCell.displayedValue = this.translate.instant(
      "stations.alarmStation.detail"
    );
    thDetail.valueCells.push(thDetailCell);

    const thStation = new TableTh();
    if (!this.eUid) {
      thStation.columnId = this.COLUMN_ID_STATION;
      const thStationCell = new ValueCell();
      thStationCell.displayedValue = this.translate.instant(
        "stations.alarmStation.station"
      );
      thStation.valueCells.push(thStationCell);
    }

    const thState = new TableTh();
    thState.columnId = this.COLUMN_ID_STATE;
    const thStateCell = new ValueCell();
    thStateCell.displayedValue = this.translate.instant(
      "stations.alarmStation.state"
    );
    thState.valueCells.push(thStateCell);

    const thAction = new TableTh();
    thAction.columnId = this.COLUMN_ID_ACTION;
    const thActionCell = new ValueCell();
    thActionCell.displayedValue = this.translate.instant(
      "stations.alarmStation.action"
    );
    thAction.valueCells.push(thActionCell);

    // const thTicket = this.createSimpleTh(
    //   this.COLUMN_ID_TICKET_ID,
    //   this.translate.instant("stations.alarmStation.ticketId")
    // );

    const thList = [
      thDateCreation,
      thDate,
      thTag,
      thDetail,
      thState,
      // thTicket,
      thAction,
    ];
    if (!this.eUid) {
      thList.splice(3, 0, thStation);
    }
    this.setHeaderCells(thList);
  }

  initDataRow(alarmsList: AlarmRealTimePaginatedList): void {
    alarmsList.list?.forEach((alarm) => {
      // const cssClassSeriousness = this.getcssClassSeriousness(alarm.seriousness);
      const tableRows = new TableRows(alarm);
      // tableRows.row.cssClass = (tableRows.row.obj.state ===  AlarmState.RAISED) ? this.CSS_CLASS_SERIOUSNESS_ACQUIT : null;

      // td - date
      const date = new TableTd();
      const dateCell = new ValueCell();
      dateCell.displayedValue = alarm.dateTimeEvent;
      dateCell.dataType = "DATE";
      date.valueCells.push(dateCell);

      // td - date creation
      const dateCreation = new TableTd();
      const dateCreationCell = new ValueCell();
      dateCreationCell.displayedValue = alarm.dateTime;
      dateCreationCell.dataType = "DATE";
      dateCreation.valueCells.push(dateCreationCell);

      // td - tag
      const tag = new TableTd();
      const tagCell = new ValueCell();
      tagCell.displayedValue = alarm.tag;
      tag.valueCells.push(tagCell);

      // td - detail
      const detail = new TableTd();
      const detailCell = new ValueCell();
      detailCell.displayedValue = alarm.message;
      detail.valueCells.push(detailCell);

      // td - station
      const station = new TableTd();
      if (!this.eUid) {
        const stationCell = new ValueCell();
        stationCell.displayedValue = alarm.stationName;
        station.valueCells.push(stationCell);
      }

      // td - state
      const state = new TableTd();
      const stateCell = new ValueCell();
      stateCell.displayedValue = this.getAlarmState(alarm);
      state.valueCells.push(stateCell);

      // td - action
      const action = new TableTd();
      const actionCell = new ValueCell();
      actionCell.displayedValue = this.translate.instant("action.history");
      actionCell.dataId = this.ID_EVENT_HISTORY;
      actionCell.cssClass = "btn  btn-sm btn--primary";
      action.valueCells.push(actionCell);

      // const tdTicketId = new TableTd();
      // const tdticketIdCell = new ValueCell();
      // tdticketIdCell.displayedValue =
      //   alarm.ticketExternalId || this.DISPLAY_NO_DATA;
      // tdticketIdCell.dataId = this.COLUMN_ID_TICKET_ID;
      // tdticketIdCell.cssClass = alarm.ticketExternalId
      //   ? this.CSS_TICKET_ID_LINK
      //   : "";
      // tdTicketId.valueCells.push(tdticketIdCell);
      // tdTicketId.getFirst().dataId = this.ID_CELL_TICKET_ID;

      // add cells
      // ================>
      tableRows.cells = [
        dateCreation,
        date,
        tag,
        detail,
        state,
        // tdTicketId,
        action,
      ];
      if (!this.eUid) {
        tableRows.cells.splice(3, 0, station);
      }

      // push row
      // ================>
      this.table.dataRow.push(tableRows);
    });
  }

  setHeaderCells(thList: TableTh[]): void {
    this.table.header.cells = thList;
  }

  getcssClassSeriousness(seriousNess: any) {
    let cssClass = this.CSS_CLASS_NO_SERIOUSNESS;
    if (seriousNess && seriousNess.label) {
      if (seriousNess.label === "1") {
        cssClass = this.CSS_CLASS_SERIOUSNESS_LEVEL1;
      } else if (seriousNess.label === "2") {
        cssClass = this.CSS_CLASS_SERIOUSNESS_LEVEL2;
      }
    }
    return cssClass;
  }

  getAlarmState(alarm: AlarmRealTime): string {
    return this.translate.instant("alarms.states." + alarm.state.toLowerCase());
  }
}
